export const DEAULT_SIZES = {
  small: {
    withoutPlaceholder: 'pt-14 pb-8',
    withPlaceholder: 'py-10',
    withIconLeft: 'pl-44',
    withoutIconLeft: 'pl-16',
    withIconRight: 'pr-44',
    withoutIconRight: 'pr-16',
  },
  regular: {
    withoutPlaceholder: 'pt-16 pb-12',
    withPlaceholder: 'py-12',
    withIconLeft: 'pl-44',
    withoutIconLeft: 'pl-16',
    withIconRight: 'pr-44',
    withoutIconRight: 'pr-16',
  },
}

export type SizeInput = keyof typeof DEAULT_SIZES
